import { createSelector } from 'reselect';
import { isPriceTypeVisible } from '%evp_ticket_frontend/js/redux/currentEvent/service/visibilityChecker';
import selectTicketType from '%evp_ticket_frontend/js/redux/currentEvent/selectors/selectTicketType';

export default createSelector(
    selectTicketType,
    state => state.current_event.priceTypes,
    (ticketType, priceTypes) => {
        if (ticketType === null) {
            return [];
        }
        return ticketType.price_types.reduce((accumulator, hash) => {
            const priceType = priceTypes[hash];
            if (isPriceTypeVisible(priceType)) {
                accumulator.push(priceType);
            }

            return accumulator;
        }, []);
    },
);
